import { post } from "./base";

export const DefaultModalData = {
  index: (params) => {
    return post("/defaults", params);
  },
};

export const TopicSlider = {
  update: (params) => {
    return post("/sliders", params);
  },
};

export const AdvancedSetting = {
  update: (topic, params) => {
    return post(`/advanced/${topic}`, params);
  },
};
